// extracted by mini-css-extract-plugin
module.exports = {"large":"Heading_large__2SRq6","small":"Heading_small__BBmVk"};